import React from 'react';
import { PageLayout } from '../components/PageLayout';
import { companyInfo } from '../mockData';

export const Terms = () => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <section className="relative -mt-20 lg:pt-40 pt-28  pb-16 md:pb-20 bg-[#262d37] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="text-2xl md:text-3xl font-bold mb-1">
              Termos e Condições
            </h1>
            <p className="text-base md:text-lg text-neutral-300">
              Última atualização: {new Date().toLocaleDateString('pt-PT')}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-10 lg:py-20 bg-[#f2f1ec]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="prose prose-neutral max-w-none space-y-12 text-neutral-800">

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">1. Termos</h2>
              <p className="text-base leading-relaxed">
                Ao aceder ao site <strong>{companyInfo.name}</strong> (gerido por <strong>{companyInfo.legalName}</strong>), concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis e reconhece que é responsável pelo cumprimento de toda a legislação local relevante. Se não concordar com algum destes termos, fica proibido de usar ou aceder a este site. Os materiais presentes neste site estão protegidos pelas leis aplicáveis de direitos de autor e marcas.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">2. Uso de Licença</h2>
              <p className="text-base leading-relaxed">
                É concedida permissão para descarregar temporariamente uma cópia dos materiais (informações ou software) presentes no site {companyInfo.name}, apenas para visualização pessoal, transitória e não comercial. Esta permissão constitui uma licença, não uma transferência de propriedade. Ao abrigo desta licença, não é permitido:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li>modificar ou copiar os materiais;</li>
                <li>usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);</li>
                <li>tentar descompilar ou fazer engenharia inversa de qualquer software presente no site {companyInfo.name};</li>
                <li>remover quaisquer notações de direitos de autor ou outras indicações de propriedade;</li>
                <li>transferir os materiais para outra pessoa ou “espelhar” os materiais noutro servidor.</li>
              </ul>
              <p className="text-base leading-relaxed">
                Esta licença termina automaticamente caso viole alguma destas restrições, podendo também ser revogada pela {companyInfo.legalName} a qualquer momento. Após encerrar a visualização dos materiais ou ao término da licença, deve eliminar quaisquer materiais descarregados, seja em formato digital ou impresso.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">3. Isenção de responsabilidade</h2>
              <p className="text-base leading-relaxed">
                Os materiais disponibilizados no site {companyInfo.name} são fornecidos “tal como estão”. A {companyInfo.legalName} não oferece garantias — expressas ou implícitas — incluindo, mas não limitado a, garantias de comercialização, adequação a um fim específico ou não violação de propriedade intelectual.
              </p>
              <p className="text-base leading-relaxed">
                A {companyInfo.legalName} não garante a precisão, fiabilidade ou resultados provenientes do uso dos materiais no site, nem assume responsabilidade por conteúdos presentes em sites vinculados ao seu domínio.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">4. Limitações</h2>
              <p className="text-base leading-relaxed">
                Em circunstância alguma a {companyInfo.legalName} ou os seus fornecedores serão responsáveis por quaisquer danos (incluindo perda de dados, prejuízo financeiro ou interrupção de atividade) decorrentes do uso ou incapacidade de usar os materiais presentes no site, mesmo que tenha sido comunicada a possibilidade desses danos. Algumas jurisdições não permitem limitações de garantias ou responsabilidade por danos consequentes, pelo que estas disposições podem não se aplicar ao utilizador.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">5. Precisão dos materiais</h2>
              <p className="text-base leading-relaxed">
                Os materiais apresentados no site {companyInfo.name} podem incluir erros técnicos, tipográficos ou fotográficos. A {companyInfo.legalName} não garante que o conteúdo seja preciso, completo ou atualizado. A empresa reserva-se o direito de alterar os materiais em qualquer momento, sem aviso prévio, não assumindo contudo a obrigação de os atualizar.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black border-b border-neutral-400 pb-2">6. Links</h2>
              <p className="text-base leading-relaxed">
                A {companyInfo.legalName} não analisa todos os sites vinculados ao seu domínio e não é responsável por qualquer conteúdo existente nesses sites externos. A inclusão de links não implica aprovação ou recomendação por parte da {companyInfo.legalName}. O acesso a sites externos é da exclusiva responsabilidade do utilizador.
              </p>
            </div>

            <div className="space-y-2 pt-4 border-t border-neutral-400">
              <h2 className="text-2xl md:text-3xl font-bold text-black">Modificações</h2>
              <p className="text-base leading-relaxed">
                A {companyInfo.legalName} poderá rever estes termos de serviço a qualquer momento, sem aviso prévio. Ao usar este site, concorda em cumprir a versão mais atualizada dos termos.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold text-black">Lei aplicável</h2>
              <p className="text-base leading-relaxed">
                Estes termos e condições são regidos e interpretados de acordo com as leis portuguesas, submetendo-se o utilizador à jurisdição exclusiva dos tribunais de Portugal.
              </p>
            </div>

          </div>
        </div>
      </section>
    </PageLayout>
  );
};
